import {
  AUTHENTICATE_APOLLO_REQUEST, AUTHENTICATE_APOLLO_SUCCEEDED, AUTHENTICATE_APOLLO_FAILED,
} from 'constants/actionTypes';

const initialState = {
  changes: {
    saving: false,
    error: null,
    configuration: {}
  }
};

function apolloReducer(state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATE_APOLLO_REQUEST:
      return {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      }

    case AUTHENTICATE_APOLLO_SUCCEEDED:
      const { configuration } = action.payload;
      return {
        ...state,
        changes: {
          ...state.changes,
          saving: false,
          configuration: configuration,
          error: null
        }
      }

    case AUTHENTICATE_APOLLO_FAILED:
      return {
        ...state,
        changes: {
          ...state.changes,
          saving: false,
          error: action.payload
        }
      }

    default:
      return state;
  }
}

export { apolloReducer }
